
define('text!editor/edit/contexts/export.html',[],function () { return '<div class="context-content">\r\n    <h4>Export</h4>\r\n\r\n    <button class="btn btn-primary" data-bind="click: exportScreenshot">Export Map as Image</button>\r\n\r\n    <button class="btn btn-primary" data-bind="click: exportKml">Export Map as KML</button>\r\n</div>\r\n';});

